import React, { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { DraftEditor } from "./DraftEditor";

const ACTION = {
  drafted: ["Πρόχειρο έτοιμο", "bg-amber-50 text-amber-700 border-amber-200"],
  sending: ["Αποστέλλεται…", "bg-sky-50 text-sky-700 border-sky-200"],
  sent: ["Στάλθηκε", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  skipped: ["Παραλείφθηκε", "bg-slate-50 text-slate-600 border-slate-200"],
  error: ["Σφάλμα", "bg-rose-50 text-rose-700 border-rose-200"],
};

const CATEGORY = {
  customer_inquiry: "Ερώτηση πελάτη", order: "Παραγγελία", partner: "Συνεργάτης", supplier: "Προμηθευτής",
  personal: "Προσωπικό", invoice_billing: "Τιμολόγηση", automated: "Αυτόματο", newsletter: "Newsletter",
  spam: "Spam", other: "Άλλο", duplicate: "Διπλό",
};

const LogItem = ({ x: initial }) => {
  const [open, setOpen] = useState(false);
  const [x, setX] = useState(initial);
  useEffect(() => setX(initial), [initial]);
  const [label, cls] = ACTION[x.action] || ACTION.skipped;
  return (
    <li className="py-3 border-b border-slate-100 last:border-0" data-testid={`email-agent-log-${x.id}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full text-left flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
        <Badge variant="outline" className={`w-fit ${cls}`}>{label}</Badge>
        <span className="text-sm font-medium text-slate-900 truncate flex-1">{x.subject || "(χωρίς θέμα)"}</span>
        <span className="text-xs text-slate-500 truncate" title={x.from}>{x.from_name ? <>{x.from_name} <span className="text-slate-400">&lt;{x.from}&gt;</span></> : x.from}</span>
        <span className="text-[11px] text-slate-400 shrink-0">{new Date(x.created_at).toLocaleString("el-GR")}</span>
      </button>
      {(x.summary || x.reason) && <p className="mt-1 text-xs text-slate-600">{x.category && <b>{CATEGORY[x.category] || x.category} · </b>}{x.summary || x.reason}</p>}
      {open && x.action === "drafted" && <DraftEditor x={x} onChange={setX} />}
      {open && x.action !== "drafted" && x.draft_body && (
        <div className="mt-2 rounded-md bg-slate-50 border border-slate-100 p-3 text-sm whitespace-pre-wrap text-slate-800" data-testid={`email-agent-log-draft-${x.id}`}>
          {x.draft_body}
          {x.attachments?.length > 0 && <div className="mt-2 text-xs text-slate-600">Συνημμένα: {x.attachments.join(", ")}</div>}
          {x.sent_at && <div className="mt-2 text-xs text-emerald-700" data-testid={`email-agent-log-sent-${x.id}`}>Στάλθηκε στο {x.sent_to} · {new Date(x.sent_at).toLocaleString("el-GR")}</div>}
        </div>
      )}
    </li>
  );
};

export const AgentLog = ({ log }) => (
  <section className="border border-slate-200 rounded-lg p-5 bg-white" data-testid="email-agent-log">
    <p className="text-xs text-slate-600 mb-2">Τα πρόχειρα αποθηκεύονται στον φάκελο «Πρόχειρα» του mailbox — τα βρίσκετε στο Outlook. Ανοίξτε ένα πρόχειρο για να το διορθώσετε, να επισυνάψετε αρχείο ή να το στείλετε. Τίποτα δεν στέλνεται αυτόματα.</p>
    <ul>
      {log.map((x) => <LogItem key={x.id} x={x} />)}
      {!log.length && <li className="text-sm text-slate-500 py-3">Δεν έχει επεξεργαστεί email ακόμη.</li>}
    </ul>
  </section>
);
